import React from 'react';
import { useSelector } from 'react-redux';
import style from '../style.module.less';
import Global from '../../../../../store/global-selectors';

const PackingSlipsPrintedCountColumn = ({ fulfillmentPlanSetId }) => {
  const fulfillmentPlanSet = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanSetById(state, {
      fulfillmentPlanSetId,
    }),
  );
  const { packingSlipPrintedCount } = fulfillmentPlanSet ?? {};

  return <div className={style['right-aligned']}>{packingSlipPrintedCount}</div>;
};

export default {
  id: 'packing-slip-printed-count',
  messageDescriptorKey: 'packingSlipPrinted',
  width: 180,
  nonsortable: true,
  render: ({ fulfillmentPlanSetId }) => <PackingSlipsPrintedCountColumn fulfillmentPlanSetId={fulfillmentPlanSetId} />,
};
